import parsePhoneNumberFromString, { isValidPhoneNumber } from "libphonenumber-js";
import { z } from "zod";

import { allCountryCodes } from "./countries";
import { userRoles } from "./enums";

const phoneNumberErrorMessage = "common:zod.phone";

export const phoneNumberSchema = z.string({ message: "common:zod.required" })
  .refine(isValidPhoneNumber, phoneNumberErrorMessage)
  .transform((value, ctx) => {
    const parsedPhoneNumber = parsePhoneNumberFromString(value);
    if (!parsedPhoneNumber) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: phoneNumberErrorMessage,
      });

      return z.NEVER;
    }

    return parsedPhoneNumber.formatInternational();
  });

export const userDetailedSchema = z.object({
  id: z.string(),
  email: z.string(),
  role: z.enum(userRoles),
  phoneNumber: z.string().nullable(),
  stripeId: z.string().nullable(),
  clerkId: z.string(),
  imgUrl: z.string(),
  isAdmin: z.boolean(),
  firstName: z.string(),
  lastName: z.string(),
  clubName: z.string().nullable(),
  clubEmail: z.string().nullable(),
  clubPhone: z.string().nullable(),
  country: z.enum(allCountryCodes),
  clubAddress: z.string().nullable(),
  clubCity: z.string().nullable(),
  createdAt: z.string(),
});
export type UserDetailedType = z.infer<typeof userDetailedSchema>;
